var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pulse_svg__clip0_13017_88740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 8h-1.653a1.334 1.334 0 00-1.287.973l-1.566 5.574a.167.167 0 01-.32 0L6.16 1.453a.167.167 0 00-.32 0L4.274 7.027A1.333 1.333 0 012.994 8h-1.66",
    stroke: "currentcolor",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pulse_svg__clip0_13017_88740"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/pulse.fa900ea4.svg";
export { SvgPulse as ReactComponent };